<div class="layout main-layout slds-grid slds-wrap">
  <ups-navbar class="navbar slds-size_12-of-12"></ups-navbar>
  <div class="content slds-col slds-container_x-large slds-container_center" [@quickFadeIn]>
    <ups-breadcrumb></ups-breadcrumb>
    <router-outlet></router-outlet>
  </div>
</div>
